export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Cyrillic-40ef113405ec0165192ad95668e6c15a.woff2";